<template>
  <div class="storageDaPing">
    <!-- 头部 -->
    <div class="heard">
        <div class="img">
          <img src="../../../assets/dapingImg/logo.png" alt />
        </div>
      <span class="title">成品发运</span>
      <div class="date">
        <span>{{ nowDate + " " + nowWeek }}</span>
      </div>
    </div>
    <!-- 内容 -->
    <div class="con">
      <div class="div">
        <div class="top">
          <div class="top_box">
            <div class="tiaoti">成品数据</div>
            <div class="top_one one">
              <span>{{this.shengyuNumber }}</span>
              <div>累计库存量</div>
            </div>
            <div class="top_one two">
              <ul>
                <li>
                  <span>{{this.chengpingData.deliveredWeight}}</span>
                  <div>已拉运量</div>
                </li>
                <li>
                  <span>{{this.sum }}</span>
              <div>实时库存量</div>
                </li>
              </ul>
            </div>
            <div class="top_one three">
              <span>{{this.chengpingData.deliveredVhCcount}}</span>
              <div>拉运车次</div>
            </div>
          </div>
          <div class="top_center"></div>
          <div class="top_box">
            <div class="tiaoti">客户库存统计</div>
             <div id="kehuChart" :style="{width: '40vw',height:'35vh'}"></div>
          </div>
          <div class="top_center"></div>
          <div class="top_box">
            <div class="tiaoti">作业监控</div>
            <div class="chartsBox">
              <div class="listTitle ">
                <div class="item">车牌号</div>
                <div class="item">司机姓名</div>
                <div class="item">货物类型</div>
                <div class="item">流向</div>
                <div class="item" style="width: 30%">派车日期</div>
              </div>
              <vue-seamless-scroll :data="taskMonitoringData"  :class-option="classOption" class="seamless-warp">
                <div class="box3">
                  <div
                    class="listBox listCont"
                    v-for="(item, index) in taskMonitoringData"
                    :key="index"
                  >
                    <div class="item">{{ item.vehicleNo }}</div>
                    <div class="item">{{ item.driverName }}</div>
                    <div class="item" >中厚板</div>
                    <div class="item">{{ item.flowtoType }}</div>
                    <div class="item" style="width: 30%">
                      {{ item.sendDate? item.sendDate:'-'}}
                    </div>
                  </div>
                </div>
              </vue-seamless-scroll>
            </div>
          </div>
        </div>
      </div>
      <div class="div_center"></div>
      <div class="div">
        <div class="bottom">
          <div class="tiaoti">车队日拉运情况</div>
          <div
            id="myChart"
            class="myChart"
            :style="{ width: '98vw', height: '40vh' }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DonMessage from '@/utils/message'
import 'echarts-liquidfill/src/liquidFill.js' // 在这里引入
import {
  finishedProduct, // 1- 数据
  taskMonitoring, // 1- 数据
  fleetTransportData // 数据

} from '@/api/data-center-server'
import {
  selectStockChart

} from '@/api/wms-stock'
export default {
  data () {
    return {
      sum: 0,
      shengyuSum: 0,
      shengyuNumber: 0,
      jinkongData: [1, 2, 3, 4, 5, 6, 7],
      chengpingData: [],
      zuoyeData: [],
      cheduiData: [],
      jiahuaData: [],
      layunData: [],
      shenyuData: [],
      nameData: [],
      fleetListData: [],
      taskMonitoringData: [],
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '' // 当前星期
    }
  },

  computed: {
    classOption () {
      return {
        step: 0.3, // 数值越大速度滚动越快
        limitMoveNum: this.jinkongData.length, // 开始无缝滚动的数据量  //this.fourDatata.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }

  },
  created () {
    this.finishedProductS()
    this.fleetTransportDataS()
    this.taskMonitoringS()

    this.currentTime()
    this.selectStockChartS()
  },
  methods: {
    // 1- 数据
    finishedProductS () {
      finishedProduct({
      })
        .then(res => {
          this.chengpingData = res[0]
          // deliveredWeight
          this.shengyuSum = this.chengpingData.deliveredWeight
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2- 数据
    fleetTransportDataS () {
      fleetTransportData({
      })
        .then(res => {
          this.fleetListData = res
          this.fleetDataS()
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2- 数据
    taskMonitoringS () {
      taskMonitoring({
      })
        .then(res => {
          this.taskMonitoringData = res
          // this.fleetDataS()
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 2.1 查询仓储租户下全部或指定客户的库存量--饼图
    selectStockChartS () {
      selectStockChart({
        customerTaxId: this.kehuAddNum
      })
        .then(res => {
          let obj = {}
          obj.customerName = '暂无信息'
          obj.allWeight = 0
          // 如果res为【】，制造数据进去
          if (res.length == 0) {
            res.push(obj)
            this.sum = 0
          }

          this.bingTuList = res
          this.storageData = []
          this.allWeight = []
          this.sum = 0

          this.bingTuList.forEach((item, index) => {
            this.allWeight.push(item.allWeight)

            let name = item.customerName // customerName客户名称
            let keHuvalue = item.allWeight // allweight库存量
            let _storage = {}
            _storage['name'] = name
            _storage['value'] = keHuvalue
            this.storageData.push(_storage) // 饼图使用的数据
          })

          let arr = []
          this.allWeight.forEach((item, index) => {
            if (item == undefined) {
              item = 0
            }
            arr.push(item)
          })
          for (var i = 0; i < arr.length; i++) {
            this.sum += arr[i]
          }
          this.sum = this.sum.toFixed('3')
          this.shengyuNumber = parseFloat(this.sum) + parseFloat(this.shengyuSum)
          this.shengyuNumber = this.shengyuNumber.toFixed(3)

          // 基于准备好的dom，初始化echarts实例
          let kehuChart = this.$echarts.init(document.getElementById('kehuChart'))

          // let myChart2 = this.$echarts.init(document.getElementById('myChart2'))
          // 绘制图表--库存量
          kehuChart.setOption({
            color: [
              '#f7765b', '#4c87ff', '#ff9e00', '#28e093', '#5caa29', '#03faec', '#efe31b'
            ],
            tooltip: {
              trigger: 'item',
              formatter: '{a} <br/>{b} : {c} ({d}%)'
            },
            title: {
              text: '库存总量\n' + '\n' + this.sum,
              left: 'center',
              top: '50%',
              textStyle: {
                color: '#fff',
                fontWeight: 'normal',
                fontSize: 14
              }
            },
            graphic: [
              {
                type: 'group',
                top: 'middle',
                left: 'center',
                id: 'data'
              }
            ],
            series: [
              {
                name: '库存总量',
                type: 'pie',
                clickable: false, // 是否开启点击
                // minAngle: 12, // 最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                avoidLabelOverlap: true, // 是否启用防止标签重叠策略
                hoverAnimation: false,
                radius: ['70%', '45%'],
                center: ['50%', '60%'],
                labelLine: {
                  normal: {
                    length: 40
                  }
                },
                data: this.storageData,

                label: {
                  align: 'left',
                  normal: {
                    formatter (v) {
                      let text = v.name + '~' + Math.round(v.percent) + '%'
                      if (text.length <= 20) {
                        return text
                      } else if (text.length > 8 && text.length <= 10) {
                        return (text = `${text.slice(0, 8)}\n${text.slice(8)}`)
                      } else if (text.length > 10 && text.length <= 18) {
                        return (text = `${text.slice(0, 8)}\n${text.slice(
                          8,
                          10
                        )}\n${text.slice(10)}`)
                      } else if (text.length > 18 && text.length <= 30) {
                        return (text = `${text.slice(0, 8)}\n${text.slice(
                          8,
                          10
                        )}\n${text.slice(10, 18)}\n${text.slice(18)}`)
                      } else if (text.length > 30) {
                        return (text = `${text.slice(0, 8)}\n${text.slice(
                          8,
                          10
                        )}\n${text.slice(10, 18)}\n${text.slice(
                          18,
                          30
                        )}\n${text.slice(30)}`)
                      }
                    },
                    textStyle: {
                      fontSize: 12
                    }
                  }
                }
              }
            ]
          })
        })
        .catch(err => {
          DonMessage.error(err.message)
        })
    },
    // 3-车队拉运量
    fleetDataS () {
      this.jiahuaData = []
      this.layunData = []
      this.shenyuData = []
      this.nameData = []
      this.fleetListData.forEach((item, index) => {
        this.nameData.push(item.name)
        // 计划吨数
        this.jiahuaData.push(item.planNum)
        // 拉运吨数
        this.layunData.push(item.completeNum)
        // 剩余吨数
        this.shenyuData.push(item.remainNum)
      })
      let myChart = this.$echarts.init(document.getElementById('myChart'))

      // 柱状图数据
      var map4Data1 = this.jiahuaData
      var map4Data2 = this.layunData
      var map4Data3 = this.shenyuData
      // 绘制图表--柱状
      myChart.setOption({
        color: ['#0DD9FE', '#52F23A', '#FFAF03'],
        // backgroundColor: "#323a5e",
        grid: {
          left: '2%',
          right: '4%',
          bottom: '9%',
          top: '25%',
          containLabel: true
        },
        legend: {
          icon: 'circle',
          data: ['日计划量', '日拉运量', '日剩余量'],
          textStyle: {
            color: '#fff'
          }
        },
        // ---  提示框 ----
        tooltip: {
          show: true, // 是否显示提示框，默认为true
          trigger: 'item', // 数据项图形触发
          axisPointer: {
            // 指示样式
            type: 'shadow',
            axis: 'auto'
          },
          padding: 5,
          textStyle: {
            // 提示框内容的样式
            color: '#fff'
          }
        },
        calculable: true,
        xAxis: {
          type: 'category',
          data: this.nameData,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: {
            interval: 0,
            formatter: function (value) {
              var ret = ''// 拼接加\n返回的类目项
              var maxLength = 4// 每项显示文字个数
              var valLength = value.length// X轴类目项的文字个数
              var rowN = Math.ceil(valLength / maxLength) // 类目项需要换行的行数
              if (rowN > 1)// 如果类目项的文字大于3,
              {
                for (var i = 0; i < rowN; i++) {
                  var temp = ''// 每次截取的字符串
                  var start = i * maxLength// 开始截取的位置
                  var end = start + maxLength// 结束截取的位置
                  // 这里也可以加一个是否是最后一行的判断，但是不加也没有影响，那就不加吧
                  temp = value.substring(start, end) + '\n'
                  ret += temp // 凭借最终的字符串
                }
                return ret
              } else {
                return value
              }
            },
            textStyle: {
              fontFamily: 'Microsoft YaHei'
            }
          }
        },
        yAxis: {
          type: 'value',
          data: ['2000', '4000', '6000', '8000'],
          axisLine: {
            show: false,
            lineStyle: {
              color: 'white'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,0.3)'
            }
          },
          axisLabel: {}
        },
        series: [
          {
            name: '日计划量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data1
          },
          {
            name: '日拉运量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data2
          },
          {
            name: '日剩余量',
            type: 'bar',
            barGap: 0,
            barWidth: '15%',
            data: map4Data3
          }
        ]
      })
    },
    // 右侧时间
    currentTime () {
      setInterval(this.getDate, 500)
    },
    getDate: function () {
      var _this = this
      let yy = new Date().getFullYear()
      let mm = new Date().getMonth() + 1
      let dd = new Date().getDate()
      let week = new Date().getDay()
      let hh = new Date().getHours()
      let mf =
        new Date().getMinutes() < 10
          ? '0' + new Date().getMinutes()
          : new Date().getMinutes()
      if (week == 1) {
        this.nowWeek = '星期一'
      } else if (week == 2) {
        this.nowWeek = '星期二'
      } else if (week == 3) {
        this.nowWeek = '星期三'
      } else if (week == 4) {
        this.nowWeek = '星期四'
      } else if (week == 5) {
        this.nowWeek = '星期五'
      } else if (week == 6) {
        this.nowWeek = '星期六'
      } else {
        this.nowWeek = '星期日'
      }
      _this.nowTime = hh + ':' + mf
      _this.nowDate = yy + '/' + mm + '/' + dd
    }
  }
}
</script>

<style lang='less' scoped>
.storageDaPing {
  width: 100%;
  height: 100vh;
  // display: flex;
  overflow: hidden;
  background: url("../../../assets/dapingImg/bg.png") 100%;
  .heard {
    width: 100%;
    height: 6vh;
    line-height: 6vh;
    display: flex;
    background: url("../../../assets/dapingImg/标题光条.png") no-repeat;
    background-size: 100% 100%;
    text-align: center;
    .title {
      flex: 1;
      font-size: 30px;
      font-weight: 700;
      color: #03faec;
    }
    .date {
      font-size: 16px;
      color: #ffdd17;
    }
    .img {
      height: 6vh;
      // position: absolute;
      z-index: 1111;
      img {
        height: 100%;
      }
    }
  }
  .con {
    // width: 100%;
    height: 92vh;
    margin-top: 1vh;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .div_center {
      height: 20px;
      width: 100%;
    }
    .div {
      flex: 1;
    }
    .top {
      display: flex;
      height: 100%;
      overflow: ;
      .top_box {
        flex: 1;
        display: flex;
        flex-direction: column;

        height: 100%;
        border: 1px solid #3bfff280;
        background-color: #3bfff215;
      }
      .top_center {
        height: 100%;
        width: 20px;
      }
      .top_one {
        flex: 1;
        padding-top: 4vh;
        span {
          color: #03faec;
          font-size: 22px;
        }
        div {
          color: #fff;
          font-size: 12px;
        }
      }
      .one {
        width: 100%;
        text-align: center;
      }
      .two {
        ul {
          display: flex;
          li {
            flex: 1;
            // height: 16vh;
            // padding-top: 20px;
            text-align: center;
          }
        }
      }
      .three {
        width: 100%;
        text-align: center;
      }
    }
    .bottom {
      height: 100%;
      overflow: hidden;
      border: 1px solid #3bfff280;
      background-color: #3bfff215;
    }
  }
  .listTitle {
    height: 4vh;
    line-height: 4vh;
    background-color: #0c46a2;
    display: flex;
    .item {
      width: 20%;
      text-align: center;
      color: #fff;
    }
  }
  .tiaoti {
    padding-left: 10px;
    height: 4vh;
    line-height: 4vh;
    font-size: 18px;
    font-weight: 700;
    color: #03faec;
    background-color: #3bfff22f;
  }
  .seamless-warp {
    overflow: hidden;
    height: 33vh;
    // line-height: 33vh;
    box-sizing: border-box;
  }
  .listBox {
    display: flex;
    padding: 8px 0;
    font-size: 14px;
    border-bottom: 1px solid #03faec;
  }
  .listBox .item {
    height: 4vh;
    line-height: 4vh;
    color: #03faec;
    width: 20%;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    word-break: break-all;
  }
}
</style>
